import { PriceChangePrice } from 'pages/trading/model';

export function calculateDailyStats(priceData?: PriceChangePrice) {
  if (!priceData) return { dailyQty: 0, dailyGmv: 0, price: 0 };

  const start = new Date(priceData.fromDate).getTime();
  const end = new Date(priceData.toDate).getTime();
  //To reflect the correct backend days count
  const days = Math.max(1, Math.ceil((end - start) / (1000 * 3600 * 24)) + 1);

  return {
    dailyQty: priceData.ordQty / days,
    dailyGmv: priceData.dailyGmv,
    price: priceData.price,
  };
}
